function ChangeSortRdc() {
    const changeSortRdc = (state, payload) => {
        const newState = Object.assign(Object.assign({}, state), { sort: {
                name: payload.key,
                direction: payload.value
            } });
        newState.metadata.forEach((value => {
            var _a;
            if (value.id == payload.key) {
                value.sortDirection = (newState.sort && ((_a = newState.sort) === null || _a === void 0 ? void 0 : _a.direction)) ? newState.sort.direction : "asc";
            }
            else {
                value.sortDirection = undefined;
            }
        }));
        newState.isLoading = true;
        return newState;
    };
    return changeSortRdc;
}
export default ChangeSortRdc;
//# sourceMappingURL=ChangeSortRdc.js.map